import type { App } from 'vue';
import type { Router } from 'vue-router';

import { SENTRY_IGNORED_ERROR_NAMES_LIST } from '@modules/core/errors/errorExclusions';
import { getEnvConfig } from '@modules/core/services/env-config/utils/envConfig';
import * as Sentry from '@sentry/vue';

export default async function registerSentry(app: App, router: Router): Promise<void> {
  const envConfig = await getEnvConfig();

  Sentry.init({
    app,
    dsn: 'https://166c1127d9bd886d1c1cd0a57e07298b@o4507645494820864.ingest.de.sentry.io/4507645517234256',
    integrations: [
      Sentry.browserTracingIntegration({ router, routeLabel: 'path' }),
      Sentry.replayIntegration(),
      Sentry.captureConsoleIntegration(),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['quints-front'],
        // Defines how to handle errors that contain third party stack frames.
        behaviour: 'apply-tag-if-contains-third-party-frames',
      }),
    ],
    release: `quints-front@${import.meta.env.PACKAGE_VERSION}`,
    environment: envConfig.env.name,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for tracing.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
    tracePropagationTargets: [],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.5,
    ignoreErrors: SENTRY_IGNORED_ERROR_NAMES_LIST,
  });
}
